/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedHeadScriptTags_metadata = {
    readonly microdata: string | null;
    readonly " $refType": "SharedHeadScriptTags_metadata";
};
export type SharedHeadScriptTags_metadata$data = SharedHeadScriptTags_metadata;
export type SharedHeadScriptTags_metadata$key = {
    readonly " $data"?: SharedHeadScriptTags_metadata$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedHeadScriptTags_metadata">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedHeadScriptTags_metadata",
  "type": "MetaData",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "microdata",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'b1b4576dd4c2a4a6bbd5990cb11c9cf0';
export default node;
